import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import DateFormat from "../../common/format/DateFormat";

class IdentityData extends Component {



  render() {

    const {intl:{formatMessage}, identity} = this.props;

    return (
      <div className={"row"}>
        <div className="list col-md-6 col-xxl-6">
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.driver-license.id'})}: </span><span>{identity && identity.licenseId}</span><br/>
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.driver-license.delivery-date'})}: </span><DateFormat layout="dateOnly" date={identity && identity.deliveryDate}/><br/>
        </div>
        <div className="list col-md-6 col-xxl-6">
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.id-card.id'})}: </span><span>{identity && identity.nationalId}</span><br/>
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.id-card.birth-date'})}: </span><DateFormat layout="dateOnly" date={identity && identity.birthDate}/><br/>
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.id-card.nationality'})}: </span><span>{identity && identity.nationality}</span><br/>
          <span className="txt-muted">{formatMessage({id:'appointment.detail.mobility.identity.id-card.validity-date'})}: </span><DateFormat layout="dateOnly" date={identity && identity.validityDate}/><br/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(IdentityData))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/mobility/IdentityData.js